const $ = jQuery.noConflict();

class ScrollTo {
    constructor() { 
         this.heroSection = document.querySelector('.page-hero--homepage');
         if ( null !== this.heroSection ) {
            this.heroSectionScroll =  this.heroSection.querySelector('.page-hero__scroll-for-more'); 
         }
    } 
    init() { 
        if ( null !== this.heroSection ) {
            this.heroSectionScroll.addEventListener('click', this.handleButtonClick);
        }   
    } 
    handleButtonClick(){
        let idSection = document.querySelector('.page-hero--homepage').nextElementSibling.id;  
        document.getElementById(idSection).scrollIntoView({ block: 'start',  behavior: 'smooth' }); 
    } 
}

export default new ScrollTo();
